import React, {useEffect, useState} from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Datalist from "./components/Datalist";
import LoginButton from "./components/LoginButton";
import Header from "./Header";

function App() {
    const [selectedSite, setSelectedSite] = useState("");
    const [user, setUser] = useState(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/auth/user`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => setUser(data.user))
            .catch(() => setUser(null));
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={
                    <div>
                        {!user ? (
                            <LoginButton />
                        ) : (
                            <>
                                <Header
                                    user={user}
                                    onLogout={() => setUser(null)}
                                    setSelectedSite={setSelectedSite}
                                />
                                <Datalist site={selectedSite} setSelectedSite={setSelectedSite} />
                            </>
                        )}
                    </div>

                } />
            </Routes>
        </BrowserRouter>
    );
}


export default App;
